import { render, staticRenderFns } from "./UserAform.vue?vue&type=template&id=597fd4b3&scoped=true&"
import script from "./UserAform.vue?vue&type=script&lang=js&"
export * from "./UserAform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597fd4b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('597fd4b3')) {
      api.createRecord('597fd4b3', component.options)
    } else {
      api.reload('597fd4b3', component.options)
    }
    module.hot.accept("./UserAform.vue?vue&type=template&id=597fd4b3&scoped=true&", function () {
      api.rerender('597fd4b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Users/Children/UserAform.vue"
export default component.exports